module.exports = __webpack_public_path__ + "img/verbinden.9cb9256a.svg";